export default "__VITE_ASSET__7WHX1RiA__"